import { flatten } from 'lodash';
import { DateTime } from 'luxon';
const HOURS = 24;
const INTERVALS_PER_HOUR = 4;
const MINUTES_IN_HOUR = 60;
const getTimes = (hours = HOURS, intervals = INTERVALS_PER_HOUR) => {
    return Array.from(Array(hours).keys()).map(hourKey => {
        const intervalLength = getIntervalLength();
        return Array.from(Array(intervals).keys()).map(intervalKey => {
            const interval = intervalKey * intervalLength;
            const padded = interval === 0 ? '0' : '';
            return `${hourKey}:${intervalKey * intervalLength}${padded}`;
        });
    });
};
const getIndexFromTimeString = (time) => {
    if (time) {
        const timeIndex = PICKER_TIMES.findIndex(timeMeta => timeMeta.time === time);
        if (PICKER_TIMES[timeIndex]) {
            return timeIndex;
        }
    }
    return undefined;
};
const getIntervalLength = (minutes = MINUTES_IN_HOUR, intervals = INTERVALS_PER_HOUR) => minutes / intervals;
const flattenedTimes = (...args) => flatten(getTimes(...args));
const getTime = (time) => DateTime.fromFormat(time, 'T');
const transformTimeToReadable = (time) => getTime(time).toFormat('t');
const getMetaFromTimeString = (time) => ({
    dateTime: getTime(time),
    label: transformTimeToReadable(time),
    time,
});
const getTimePickerTimes = (...args) => flattenedTimes(...args).map(getMetaFromTimeString);
const PICKER_TIMES = getTimePickerTimes();
const cutoffCompareFactory = (isUntil) => {
    return (value, index) => {
        const currentValueIndex = PICKER_TIMES.findIndex(time => time.time === value);
        const comparison = isUntil ? index > currentValueIndex : index < currentValueIndex;
        if (comparison) {
            return PICKER_TIMES[index].time;
        }
        return value;
    };
};
const getCutoffUntil = cutoffCompareFactory(true);
const getCutoffAfter = cutoffCompareFactory(false);
const getTimeStringFromDateTime = (date) => {
    const { minute, hour } = date;
    const padded = minute === 0 ? '0' : '';
    return `${hour}:${minute}${padded}`;
};
const roundUpToInterval = (date, intervals = INTERVALS_PER_HOUR) => {
    const step = MINUTES_IN_HOUR / intervals;
    const base = date.set({ second: 0, millisecond: 0 });
    const remainder = base.minute % step;
    return remainder === 0 ? base : base.plus({ minutes: step - remainder });
};
export { getIndexFromTimeString, getCutoffAfter, getCutoffUntil, PICKER_TIMES, INTERVALS_PER_HOUR, transformTimeToReadable, getTimeStringFromDateTime, roundUpToInterval, };
